<template>
  <li>
    <v-card :elevation="0" class="card">
      <v-layout :wrap="$vuetify.breakpoint.xsOnly">
        <v-flex shrink class="pa-2" :style="{ minWidth: '0' }">
          <p class="text-truncate">{{ name }}</p>
          <div class="caption grey--text">
            <div>{{ datetime | DateFormat('DD/MM/YYYY hh:mm A') }}</div>
            <div>{{ $t('Created by') }}: {{ author || '-' }}</div>
          </div>
          <div v-if="scheduledDatetime" class="mt-2">
            <v-chip small color="info" text-color="white">
              <v-avatar>
                <v-icon>schedule</v-icon>
              </v-avatar>
              {{ scheduledDatetime | DateFormat('DD/MM/YYYY hh:mm A') }}
            </v-chip>
          </div>
        </v-flex>
        <v-spacer />
        <v-flex shrink class="pa-2">
          <div>
            <v-btn
              v-if="$listeners.edit"
              icon
              small
              outline
              color="primary"
              class="ma-1"
              @click="$emit('edit')"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
            <v-btn
              v-if="$listeners.view"
              icon
              small
              outline
              color="primary"
              class="ma-1"
              @click="$emit('view')"
            >
              <v-icon small>visibility</v-icon>
            </v-btn>
            <v-btn
              v-if="$listeners.duplicate"
              icon
              small
              outline
              color="primary"
              :loading="duplicating"
              class="ma-1"
              @click="$emit('duplicate')"
            >
              <v-icon small>content_copy</v-icon>
            </v-btn>
            <v-btn
              v-if="$listeners.delete"
              icon
              small
              outline
              color="primary"
              :loading="deleting"
              class="ma-1"
              @click="$emit('delete')"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card>
  </li>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    datetime: {
      type: Date,
      default: null
    },
    author: {
      type: String,
      default: ''
    },
    scheduledDatetime: {
      type: Date,
      default: null
    },
    deleting: {
      type: Boolean,
      default: false
    },
    duplicating: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  border: 1px solid var(--primary-color);
  border-radius: 8px 8px 0 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/AssetWise/ExecutiveBroadcast/Item.vue